/**
 * Shared icon registry for patient tabs + custom fields.
 * Keep in sync across TabsAdmin (picker) and PatientCustomTabContent (render).
 */
import {
  Layout, FileText, Shield, Pill, Activity, UserCog, Hospital,
  Mail, Phone, MapPin, Calendar, Heart, AlertCircle, ClipboardList,
  Stethoscope, Syringe, User, Users, DollarSign, Briefcase, Clock, Home,
  Star, Bookmark, Tag, Hash, CreditCard, Check, Building2, Globe,
} from 'lucide-react';

export const TAB_ICONS = {
  Layout, FileText, Shield, Pill, Activity, UserCog, Hospital,
  Mail, Phone, MapPin, Calendar, Heart, AlertCircle, ClipboardList,
  Stethoscope, Syringe, User, Users, DollarSign, Briefcase, Clock, Home,
  Star, Bookmark, Tag, Hash, CreditCard, Check, Building2, Globe,
};

export function IconByName({ name, className = 'w-4 h-4' }) {
  const C = TAB_ICONS[name] || FileText;
  return <C className={className} />;
}
